module.exports = __webpack_public_path__ + "img/logo.f92cb1d4.png";